// Footer.js

import React from 'react';

const Footer = () => {
  return (
    <footer
      style={{
        position: 'fixed',
        bottom: 0,
        width: '100%',
        textAlign: 'center',
        backgroundColor: '#fff',
        padding: 10,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 20,
        fontSize: 14,
        color: '#666',
        zIndex: 10,
      }}
    >
      <span>Terms of Use</span>
      <span>&copy; {new Date().getFullYear()} CollabKare. All rights reserved.</span>
      <span>Contact Us</span>
    </footer>
  );
};

export default Footer;
